import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useToast } from "components/common/custom-toast/Toast";

const AlgoPrivateRoute = ({ component: Component }) => {
  const isLoggedIn = useSelector((state) => state?.user?.isLoggedIn === true);
  const brokerLoggedIn = useSelector((state) => state?.user?.brokerLoggedIn === true);
  const toast = useToast()

  if (!isLoggedIn) {
    toast.error("Please login to access Algo signals");
    return <Navigate to="/authentication/login" />;
  }

  if (!brokerLoggedIn) {
    toast.error("Please connect your broker account to access Algo signals");
    return <Navigate to="/trading/broker-accounts" />;
  }

  return <Component />;
};

export default AlgoPrivateRoute;
